import VueRouter from 'vue-router'
import { Store } from 'vuex'

export default {
  notification: {},
}
